import { render, staticRenderFns } from "./MaterialTypeModal.vue?vue&type=template&id=35b65010&scoped=true&"
import script from "./MaterialTypeModal.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTypeModal.vue?vue&type=style&index=0&id=35b65010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b65010",
  null
  
)

component.options.__file = "MaterialTypeModal.vue"
export default component.exports